/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 * @file vendors@template.collection.js
 * @file template.collection.js
 *
 */

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// function initSortBy() {
//   [].forEach.call(document.querySelectorAll('.sortdropdown select'), function(selectId) {
//     var selectedValue = selectId.options[selectId.selectedIndex].value;
//     var selectedText = selectId.options[selectId.selectedIndex].text;
//     selectId.style.width = (selectedText.length * 8) + "px";
//
//     // Add existing sort parameters to current URL
//     selectId.addEventListener('change', function(e) {
//       var value = e.currentTarget.value;
//       Shopify.queryParams.sort_by = value;
//       applyFilter();
//     });
//   });
//  }

function initFilters() {
  [].forEach.call(document.querySelectorAll(".filter-category"), function(x) {
    x.addEventListener("click", function(e) {
      e.currentTarget.classList.toggle("expanded");
    });
  });

  [].forEach.call(
    document.querySelectorAll(".filter-values .filter-value"),
    function(x) {
      x.addEventListener("click", function(e) {
        const { filterName, filterValue, active } = e.currentTarget.dataset;
        if (filterName === "sort_by") {
          Shopify.queryParams[filterName] = filterValue;
        } else if (Shopify.queryParams[filterName]) {
          const arr = Shopify.queryParams[filterName].split(",");
          Shopify.queryParams[filterName] = active
            ? arr
                .filter(
                  x =>
                    decodeURI(x)
                      .replace(/\+/g, " ")
                      .replaceAll("%2B", " ") !== filterValue
                )
                .join(",")
            : [...arr, filterValue].join(",");
        } else {
          Shopify.queryParams[filterName] = filterValue;
        }
        applyFilter();
      });
    }
  );
}

function initFiltersToggleMobile() {
  [].forEach.call(document.querySelectorAll("[data-filter-button]"), function(
    filterToggle
  ) {
    filterToggle.addEventListener("click", function(e) {
      const filterPopup = document.querySelector(
        '[data-section-type="collection"] .filters'
      );
      if (filterPopup && filterPopup.getAttribute("data-show")) {
        filterPopup.removeAttribute("data-show");
      } else {
        filterPopup && filterPopup.setAttribute("data-show", true);
      }
    });
  });
}

function initFilterSearch() {
  [].forEach.call(
    document.querySelectorAll(".filter-category + .filter-search"),
    function(fs) {
      fs.addEventListener("input", function(e) {
        [].forEach.call(
          e.currentTarget.parentNode.querySelectorAll(
            ".filter-values .filter-value"
          ),
          function(fv) {
            if (
              fv.dataset.filterValue
                .toLowerCase()
                .includes(e.currentTarget.value.toLowerCase())
            ) {
              fv.classList.remove("hide");
            } else {
              fv.classList.add("hide");
            }
          }
        );
      });
    }
  );
}

function applyFilter() {
  delete Shopify.queryParams.page;
  Shopify.queryParams["section-id"] = document.querySelector(
    '[data-section-type="collection"]'
  )?.dataset?.sectionId;
  const params = new URLSearchParams(Shopify.queryParams)
    .toString()
    .replaceAll("%2B", "+");
  document
    .querySelector('[data-section-type="collection"] .collection-data')
    .classList.add("loading");
  fetch(`${window.location.pathname}?${params}`)
    .then(response => response.text())
    .then(html => {
      document
        .querySelector('[data-section-type="collection"] .collection-data')
        .classList.remove("loading");
      const innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector('[data-section-type="collection"] .collection-data')
        .innerHTML; // get just the products/filter
      document.querySelector(
        '[data-section-type="collection"] .collection-data'
      ).innerHTML = innerHTML; // replace the html

      history.replaceState(
        {},
        "",
        `${window.location.pathname}${params && "?".concat(params)}`
      ); // update the page state/history
      refreshPage();
    });
}
// document.querySelector(".load-more-wrapper .load-more-numbers")
//   ? (document.querySelector(
//       ".load-more-wrapper .load-more-numbers"
//     ).textContent = `1 - ${1 * 12} of ${document
//       .querySelector(".load-more-wrapper .load-more-numbers")
//       ?.getAttribute("data-total-products")} products`)
//   : null;
if (document.querySelector(".load-more-wrapper .load-more-numbers")) {
  document.querySelector(
    ".load-more-wrapper .load-more-numbers"
  ).textContent = `1 - ${Number(
    document.querySelectorAll(".product-grid .products .product-card").length
  )} of ${document
    .querySelector(".load-more-wrapper .load-more-numbers")
    ?.getAttribute("data-total-products")} products`;
}

function getPage() {
  Shopify.queryParams.page = (Number(Shopify.queryParams.page) || 1) + 1;

  Shopify.queryParams["section-id"] = document.querySelector(
    '[data-section-type="collection"]'
  )?.dataset?.sectionId;
  const params = new URLSearchParams(Shopify.queryParams)
    .toString()
    .replaceAll("%2B", "+");
  document
    .querySelector('[data-section-type="collection"] .collection-data')
    .classList.add("loading");

  fetch(`${window.location.pathname}?${params}?limit=48`)
    .then(response => response.text())
    .then(html => {
      document
        .querySelector(
          '[data-section-type="collection"] .product-grid .products'
        )
        .classList.remove("loading");
      console.log("html", html);
      const innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(
          '[data-section-type="collection"] .product-grid .products'
        ).innerHTML; // get just the products/filter
      document.querySelector(
        '[data-section-type="collection"] .product-grid .products'
      ).innerHTML += innerHTML; // add the new page html to the old grid of products.

      history.replaceState(
        {},
        "",
        `${window.location.pathname}${params && "?".concat(params)}`
      ); // update the page state/history
      document
        .querySelector('[data-section-type="collection"] .collection-data')
        .classList.remove("loading");

      document.querySelector(
        ".load-more-wrapper .load-more-numbers"
      ).textContent = `1 - ${Number(
        document.querySelectorAll(".product-grid .products .product-card")
          .length
      )} of ${document
        .querySelector(".load-more-wrapper .load-more-numbers")
        ?.getAttribute("data-total-products")} products`;

      refreshPage();
    });
}

function refreshPage() {
  initFilters();
  // initSortBy();
  initFiltersToggleMobile();
  initFilterSearch();
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.querySelector('[data-section-type="collection"]')) {
    refreshPage();
  }
  document.querySelector(".load-more")?.addEventListener("click", function(y) {
    getPage();

    if (
      Number(Shopify.queryParams.page) ===
      Number(y.target.getAttribute("data-total-pages"))
    ) {
      y.target.style.display = "none";
    } else {
      y.target.style.display = "flex";
    }
  });
});
